export const ENABLE_DEBUG_LOGS = false;
export const ENABLE_OTA_LOGS = ENABLE_DEBUG_LOGS;
export const ENABLE_PROTECTED_ROUTE_LOGS = ENABLE_DEBUG_LOGS;
export const ENABLE_LOGIN_LOGS = ENABLE_DEBUG_LOGS;
export const ENABLE_APP_STATE_LOGS = ENABLE_DEBUG_LOGS;
export const ENABLE_BIOMETRIC_LOGS = ENABLE_DEBUG_LOGS;
// Gates the [AUTH-DEBUG] console.log calls in authSlice and store middleware.
// Sentry breadcrumbs / captureMessage are independent of this flag — they
// always fire so we have remote diagnostics in production.
export const ENABLE_AUTH_LOGS = ENABLE_DEBUG_LOGS;

// Tagged [KEYCHAIN-AUDIT] in console output so each call to
// getRefreshTokenSecure is filterable in Xcode/Safari independently of
// the broader debug log flags. Off in production; the reinstall-detected
// signal still reaches Sentry via captureMessage in biometric.ts.
export const ENABLE_KEYCHAIN_AUDIT_LOGS = false;

// QA-only override: when non-null, shrinks auth.expires_at to
// `execute_at + N minutes` so the resume biometric reauth flow can be
// exercised without waiting for the real server-issued expiry. MUST be
// `null` in production builds.
export const QA_FORCE_AUTH_EXPIRY_MINUTES: number | null = null;
export const ENABLE_PROTECTED_ROUTE_TELEMETRY =
  import.meta.env.VITE_ENVIRONMENT === "prod";

// Flip to `true` locally to debug the app version gate (fetch, cache,
// resume re-check). Leave `false` in production builds.
export const ENABLE_APP_VERSION_LOGS = false;

// Flip to `true` to dump device model, viewport size, and safe-area insets
// each time the mobile drawer opens. Off in production.
export const ENABLE_NAVBAR_DRAWER_LOGS = ENABLE_DEBUG_LOGS;
